exports = module.exports = require("./../../../../node_modules/.npminstall/css-loader/0.23.1/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".wave{overflow:hidden;right:0;bottom:0;z-index:-1}.wave,.wave-ripple{position:absolute;left:0;top:0;pointer-events:none}.wave-ripple{background:rgba(0,0,0,.15);margin-top:-50%;margin-left:-50%;border-radius:100%;-webkit-transform:scale(0);transform:scale(0);-webkit-animation-name:ripple;animation-name:ripple;-webkit-animation-timing-function:ease-out;animation-timing-function:ease-out}@-webkit-keyframes ripple{to{opacity:0;-webkit-transform:scale(2);transform:scale(2)}}@keyframes ripple{to{opacity:0;-webkit-transform:scale(2);transform:scale(2)}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/css-loader/0.23.1/css-loader!./~/.npminstall/postcss-loader/0.8.2/postcss-loader!./~/.npminstall/less-loader/2.2.3/less-loader!./src/components/Components/Wave/index.less
 ** module id = 511
 ** module chunks = 0
 **/